import React from 'react';
import { TwitterIcon, TwitterShareButton } from 'react-share';
import twitterLogo from '../../assets/img/icon/twitter.png';
//adding new campaign page
const TwitterShare = ({ tweetTitle, tweetLink }) => {
  return (
    <TwitterShareButton
      className="twitter-icon mfp-link"
      url={tweetLink}
      title={`${tweetTitle}`}
    >
      <img src={twitterLogo} alt="twitterLogo" width={'30px'} />
    </TwitterShareButton>
  );
};

export default TwitterShare;
